import { render, staticRenderFns } from "./resultMember.vue?vue&type=template&id=530cfeb6&scoped=true&"
import script from "./resultMember.vue?vue&type=script&lang=js&"
export * from "./resultMember.vue?vue&type=script&lang=js&"
import style0 from "./resultMember.vue?vue&type=style&index=0&id=530cfeb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530cfeb6",
  null
  
)

export default component.exports